import { render } from "./VesCalendarGroup.vue?vue&type=template&id=00afa862&scoped=true"
import script from "./VesCalendarGroup.vue?vue&type=script&lang=js"
export * from "./VesCalendarGroup.vue?vue&type=script&lang=js"

import "./VesCalendarGroup.vue?vue&type=style&index=0&id=00afa862&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00afa862"]])

export default __exports__